import * as React from "react";

import { routeConfig } from "../../../../config/language/ja-JP/presentation/route_text";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../common/organism/progress";
import { TBreadcrumbItem } from "../../../type/common";
import CustomerMypageMainPasswordForm from "./password_update/customer_mypage_main_password_form";

interface IProps {
  isLoading: boolean;
  handleUpdatePasswordSubmit: (values: any) => void;
}

const CustomerMyPagePasswordUpdateComponent: React.FC<IProps> = (props) => {
  const { isLoading, handleUpdatePasswordSubmit } = props;

  const breadcrumbItems: TBreadcrumbItem[] = [
    routeConfig.customerRoot,
    routeConfig.customerMypage,
    routeConfig.customerMypageEmailUpdate,
  ];

  return (
    <React.Fragment>
      {isLoading && <Progress canAnimation={false} />}

      <PageWrapper>
        <div style={{ maxWidth: 600, margin: "0 auto" }}>
          <Breadcrumbs breadcrumbItems={breadcrumbItems} />
          <CustomerMypageMainPasswordForm
            onSubmit={handleUpdatePasswordSubmit}
            enableReinitialize={true}
          />
        </div>
      </PageWrapper>
    </React.Fragment>
  );
};

export default CustomerMyPagePasswordUpdateComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/mypage/customer_mypage_password_update.tsx